import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import IconMC from '../../../../../components/IconMC';
import ToggleSwitchMC from '../../../../../components/ToggleSwitchMC';
import QuillMC from '../../../../../components/QuillMC';

import { useOrderTermsConditions } from '../../../hooks/useOrderTermsConditions';

const OrderTermsConditions = memo(({ action }) => {
  const { t } = useTranslation('Orders');

  const {
    retailerInfo,
    contentValue,
    updateTerms,
    handleContentChange,
    toggleUpdateTerms
  } = useOrderTermsConditions();

  return (
    <div className="tw-wrapper">
      <div className="tw-flex tw-flex-col tw-gap-2">
        {action === 'new'
          && retailerInfo.terms_conditions_content?.length > 0 && (
            <div className="tw-flex tw-items-center tw-rounded-full tw-bg-yellow-50 tw-border tw-border-yellow-100 tw-px-2 tw-py-1 tw-gap-1">
              <IconMC name="info-outline" className="tw-text-yellow-600" />
              <div className="tw-flex tw-gap-1 tw-font-medium">
                <span className="tw-text-yellow-600 tw-text-xs">
                  {t('orderInfo.termsTitle')}
                </span>
                <a
                  href={`/retailers/${ENV.SLUG}/edit_business_info`}
                  className="tw-text-blue-950 tw-text-xs"
                >
                  {t('orderInfo.termsSubtitle')}
                </a>
              </div>
            </div>
        )}

        <span className="tw-text-xs tw-text-blue-500">
          {t('orderInfo.termsAndConditions')}
        </span>

        {!retailerInfo.terms_conditions_content?.length && (
          <ToggleSwitchMC
            isOn={updateTerms}
            handleToggle={toggleUpdateTerms}
            label={t('orderInfo.actionLabel')}
            labelClassName="!tw-text-xs"
          />
        )}

        <QuillMC
          name="terms_and_condition.terms_conditions_content"
          value={contentValue}
          onChange={handleContentChange}
        />
      </div>
    </div>
  );
});

OrderTermsConditions.displayName = 'OrderTermsConditions';

export default OrderTermsConditions;
